"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentConfirmButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../Button");
const PaymentConfirmButton = (props) => {
    const { confirm, disabled, hidden } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/ConfirmButton:label', defaultMessage: 'Confirm' }), onClick: confirm, disabled: disabled }));
};
exports.PaymentConfirmButton = PaymentConfirmButton;
//# sourceMappingURL=ConfirmButton.js.map